// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './PopupActionsSection.scss';

const PopupActionsSection = ({ children, className }) => (
    <div className={classNames('PopupActionsSection', className)}>{children}</div>
);

PopupActionsSection.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
};

export default PopupActionsSection;
